import { AmagiThemeProvider } from '@amagimedia/amagi-design-system';
import type { FC } from 'react';
import { QueryClientProvider } from 'react-query';
import { DefaultFeatureFlags } from '../constants/featureFlags';
import { ConfigProvider, ValidateUserProviderStvV2 } from '../contexts';
import { FeatureFlagsProvider } from '../contexts/FeatureFlags';
import { queryClient } from '../queryClient';
import { IConfig, ILoginDataStvV2 } from '../types';

interface IProviderProps {
  stylesPrefix: string;
  data?: ILoginDataStvV2 | null;
  config?: IConfig;
}

export const StvV2Provider: FC<IProviderProps> = (props) => {
  return (
    <FeatureFlagsProvider featureFlags={DefaultFeatureFlags}>
      <QueryClientProvider client={queryClient}>
        <ValidateUserProviderStvV2 data={props.data}>
          <AmagiThemeProvider
            stylesPrefix={props.stylesPrefix ? props.stylesPrefix : ''}
          >
            <ConfigProvider config={props.config as unknown as IConfig}>
              {props.children}
            </ConfigProvider>
          </AmagiThemeProvider>
        </ValidateUserProviderStvV2>
      </QueryClientProvider>
    </FeatureFlagsProvider>
  );
};
